import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { CalendarModel } from 'src/app/models/config/calendar.model';
import { CalendarService } from 'src/app/service/calendar.service';
import { NotificationService } from 'src/app/service/notification.service';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { MatSort, Sort } from '@angular/material/sort';
import { PayrollReport } from 'src/app/models/reports/payroll-report.model';

@Component({
  selector: 'app-payroll-report',
  templateUrl: './payroll-report.component.html',
  styleUrls: ['./payroll-report.component.css']
})
export class PayrollReportComponent implements OnInit {
  mySalesChannelSet: any;
  calendarTypes: CalendarModel[];
  calendarData: CalendarModel[];
  filteredCalderData: Observable<CalendarModel[]> | undefined;
  calendarCtrl = new FormControl();
  filteredPayrollData: PayrollReport[] = [];

  ordersTableColumns: TableColumn[];
  headder: string = 'Search Results';
  fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  fileExtension = '.xlsx';
  fileName: string = 'PayrollReport';
  columnsData: any;
  
  constructor(private calendarService: CalendarService, private notificationService: NotificationService,
    private httpService: HttpClient, private exportExcelService: ExportExcelService) { }
  public calendarModel = new CalendarModel(0, '', null, null, null, null, '', '', '', '', null, '', null, '', false, null,'','','');
  public selectedCalendarModel = new CalendarModel(0, '', null, null, null, null, '', '', '', '', null, '', null, '', false, null,'','','');


  ngOnInit(): void {
    this.loadData();
  }

  public searchPayrollReport() {
    if (this.calendarModel.calendarType != null && this.calendarModel.commPeriod != null
      && this.calendarModel.commPeriod != ''){
        console.log(this.selectedCalendarModel);
        this.calendarService.getPayrollReportByCalrun(this.selectedCalendarModel.cal_run_id)
      .subscribe((data: PayrollReport[]) => {
        this.initializeColumns()
        this.filteredPayrollData = data;
        console.log(this.filteredPayrollData);
      });
      }
     
    else {
      this.notificationService.notify(NotificationType.ERROR, "Please Select Payroll Calendar and Comm Period");
    }
  }

  public getCommPeriodValues(event: any) {
    this.calendarService.getCommPeriodValues(this.calendarModel.calendarType)
      .subscribe((data: CalendarModel[]) => {
        this.calendarData = data;
        this.filterCalData();
        console.log(this.calendarData);
      });
  }

  public setToCalndarModel(calModel: CalendarModel, event: any) {
    console.log(event.source.selected);
    if (event.source.selected)
      this.selectedCalendarModel = calModel;
    console.log(this.selectedCalendarModel);
  }

  filterCalData() {
    this.filteredCalderData = this.calendarCtrl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value))
    );
  }
  private _filter(value: string): CalendarModel[] {
    const filterValue = this._normalizeValue(value);
    return this.calendarData.filter(item => this._normalizeValue(item.commPeriod).includes(filterValue));
  }

  private _normalizeValue(value: string): string {
    return value.toString().toLowerCase().replace(/\s/g, '');
  }
  private loadData() {
    this.calendarService.getCalenarTypes()
      .subscribe((data: CalendarModel[]) => {
        this.calendarTypes = data;
      });
  }

  public exportExcel(): void {
    const exportTitle = `PayrollReport_${this.selectedCalendarModel.commPeriod}`;
    this.exportExcelService.exportFromJsonRows(this.filteredPayrollData, exportTitle);
  }

  customSort(sortParameters: Sort) {
    console.log('=====', sortParameters);
    // const keyName = sortParameters.active;
    // if (sortParameters.direction === 'asc') {
    //   this.filteredUserData = this.filteredUserData.sort((a: AddUser, b: AddUser) => a[keyName].localeCompare(b[keyName]));
    // } else if (sortParameters.direction === 'desc') {
    //   this.filteredUserData = this.filteredUserData.sort((a: AddUser, b: AddUser) => b[keyName].localeCompare(a[keyName]));
    // }
    // console.log('=====', this.filteredUserData);
    // //return this.filteredUserData ;

  }

  initializeColumns(): void {
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.ordersTableColumns = this.columnsData.PayrollReport;
        console.log(this.ordersTableColumns);
      }
    );
  }

}
